<div id="element-form-controls" [class.active]="(elementFormService.dirty$ | async)">
  <button mat-flat-button color="primary" (click)="submit()">{{ 'save' | translate }}</button>
  <button mat-button (click)="cancel()">{{ 'cancel' | translate }}</button>
</div>
